/* TC product page helpers (loaded by main-product).
   1. Quote-only variants: when the selected variant costs $0 (and the theme setting is on),
      the buy box swaps to a quote request. Runs on every variant change so it never goes stale.
   2. Collapsible rows: one open at a time. Native <details name> does this in current browsers;
      this covers older ones. */
(function () {
  if (window.tcProductInit) return;
  window.tcProductInit = true;

  function applyQuote(section, variant) {
    if (!section) return;
    var link = section.querySelector('[data-tc-quote-link]');
    if (!link) return;
    var isQuote = !!variant && Number(variant.price) === 0;
    section.classList.toggle('tc-product--quote', isQuote);
    if (variant) {
      var label = link.dataset.product + (variant.title && variant.title !== 'Default Title' ? ' (' + variant.title + ')' : '');
      link.href = link.dataset.base + encodeURIComponent('Quote request: ' + label);
    }
  }

  function subscribeVariants() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var d = event && event.data;
      if (!d) return;
      var section = document.querySelector('.tc-product[data-section="' + d.sectionId + '"]') ||
        document.querySelector('.tc-product');
      applyQuote(section, d.variant);
    });
    return true;
  }

  function groupAccordions() {
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!(d instanceof HTMLDetailsElement) || !d.open || !d.dataset.tcAccGroup) return;
      document.querySelectorAll('details[data-tc-acc-group="' + d.dataset.tcAccGroup + '"][open]').forEach(function (other) {
        if (other !== d) other.open = false;
      });
    }, true);
  }

  function init() {
    if (!subscribeVariants()) {
      var tries = 0;
      var t = setInterval(function () { if (subscribeVariants() || ++tries > 40) clearInterval(t); }, 100);
    }
    groupAccordions();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
